import OfferItem from './OfferItemV2';

export default OfferItem;
